import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setPressureUnit } from '../../actions/GlobalsActions';
import { PRESSURE_UNIT } from '../../constants/SettingsKeys';

require('./UserSettings.scss');

class PressureUnitSelect extends React.Component {
  constructor(props, context) {
    super(props);

    this.options = [
      { ID: 'bar', Name: context.t('bar') },
      { ID: 'meter', Name: context.t('meter') },
      { ID: 'kpa', Name: context.t('kpa') },
      { ID: 'psi', Name: context.t('psi') },
    ];
  }

  onChange(pressureUnit) {
    this.props.dispatch(setPressureUnit(pressureUnit));
    localStorage.setItem(PRESSURE_UNIT, pressureUnit);
  }

  render() {
    const { pressureUnit } = this.props;
    return (
      <div className="lang-select">
        <select
          onChange={(e) => this.onChange(e.target.value)}
          value={pressureUnit || 'bar'}
        >
          {this.options.map((option) => (
            <option key={option.ID} value={option.ID}>
              {option.Name}
            </option>
          ))}
        </select>
      </div>
    );
  }
}

PressureUnitSelect.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  pressureUnit: state.local.pressureUnit,
}))(PressureUnitSelect);
